// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__11pkW","value":"styles_value__1ZQ5c","title":"styles_title__3aoIn"};